import {useMutation} from '@tanstack/react-query';
import {MUTATION_KEYS} from 'infra/libs/react-query/mutationKeys';
import {postVoiceTranscriptionTermsAccept} from '../../services/postVoiceTranscriptionTermsAccept';
import {PostVoiceTranscriptionTermsAcceptParams} from 'domain/usecases';

export const usePostVoiceTranscriptionTermsAcceptMutation = () =>
	useMutation({
		mutationKey: [MUTATION_KEYS.VOICE_TRANSCRIPTION_TERMS_ACCEPT],
		mutationFn: ({Origem}: PostVoiceTranscriptionTermsAcceptParams) =>
			postVoiceTranscriptionTermsAccept({Origem}),
	});
